<template>
    <div id="app" v-cloak>
        <Header @togglemap="toggleMap" :is-show-map="show.map" />
        <SideBar
            @get-current-position="getCurrentPosition"
            @hide-map="toggleShow({ name: 'map', isShow: false })"
        ></SideBar>
        <div class="main-content">
            <div class="left-side-wrapper">
                <keep-alive v-if="$route.meta.keepAlive">
                    <router-view
                        @setloading="setLoading"
                        @alert="commonAlert"
                        class="main-wrapper"
                        @show-map="toggleShowMap"
                    >
                    </router-view>
                </keep-alive>
                <router-view
                    v-else
                    @setloading="setLoading"
                    @alert="commonAlert"
                    class="main-wrapper"
                    @show-map="toggleShowMap"
                >
                </router-view>

                <Footer></Footer>
                <slot name="footer"></slot>
            </div>

            <MapWrapper
                @loading="setLoading($event)"
                ref="mapWrapper"
            ></MapWrapper>
        </div>

        <StatusAlert
            :statusCode="httpStatus.statusCode"
            :triggerOpen="httpStatus.isShow"
            :statusData="httpStatus.statusData"
        />
        <CommonAlert
            :msg="alertData.msg"
            :triggerOpen="alertData.isShow"
            :callback="alertData.callback"
        />
        <CommonConfirm
            :msg="confirmData.msg"
            :triggerOpen="confirmData.isShow"
            :callback="confirmData.callback"
            :is-show-cancel-btn="confirmData.isShowCancelBtn"
            :submit-btn-text="confirmData.submitBtnText"
        />
        <!-- 使用手冊 -->
        <div
            class="modal fade menu-modal"
            id="userManualModal"
            tabindex="-1"
            aria-labelledby="userManualModalLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="menu-wrapper">
                            <div class="title">川柳不息導覽平台使用手冊</div>
                            <div class="describe">
                                歡迎使用川柳不息導覽平台，<br />讓我們一起了解更多臺中河川的資訊吧!
                            </div>
                            <ul>
                                <li class="menu-item">
                                    <div class="img-wrapper">
                                        <img
                                            src="@/assets/menu_ic_home.png"
                                            alt="首頁"
                                        />首頁
                                    </div>
                                    <div class="menu-body">
                                        在首頁，你可以找到關於臺中河川的最新消息以及活動行事曆，還有不同遊玩河川的導覽方式。
                                    </div>
                                </li>
                                <li class="menu-item river">
                                    <div class="img-wrapper">
                                        <img
                                            src="@/assets/menu_ic_river.png"
                                            alt="川流城事"
                                        />川流城事
                                    </div>
                                    <div class="menu-body">
                                        在川流城事單元中，除了可以認識臺中七大河川以外，還可以找到河川周邊的景點唷！
                                    </div>
                                </li>
                                <li class="menu-item event">
                                    <div class="img-wrapper">
                                        <img
                                            src="@/assets/menu_ic_news.png"
                                            alt="川柳大小事"
                                        />川柳大小事
                                    </div>
                                    <div class="menu-body">
                                        在川柳大小事單元中，你可以掌握臺中河川相關的最新消息，也可以看到舉辦的相關活動。
                                    </div>
                                </li>
                                <li class="menu-item guide">
                                    <div class="img-wrapper">
                                        <img
                                            src="@/assets/menu_ic_guide.png"
                                            alt="走讀河川"
                                        />走讀河川
                                    </div>
                                    <div class="menu-body">
                                        在走讀河川的單元中，你有多種遊覽河川的選擇，不妨每一個遊覽方式都可以點選看看。
                                    </div>
                                </li>
                                <li class="menu-item game">
                                    <div class="img-wrapper">
                                        <img
                                            src="@/assets/menu_ic_game.png"
                                            alt="互動遊戲"
                                        />互動遊戲
                                    </div>
                                    <div class="menu-body">
                                        好玩趣味的遊戲帶你更了解柳川的一切。
                                    </div>
                                </li>
                                <li class="menu-item campaign">
                                    <div class="img-wrapper">
                                        <!-- <i
                                            class="fa fa-trophy"
                                            aria-hidden="true"
                                        ></i> -->
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 576 512"
                                            style="fill:#C28148;width:1.166rem;"
                                        >
                                            <path
                                                d="M572.1 82.38C569.5 71.59 559.8 64 548.7 64h-100.8c.2422-12.45 .1078-23.7-.1559-33.02C447.3 13.63 433.2 0 415.8 0H160.2C142.8 0 128.7 13.63 128.2 30.98C127.1 40.3 127.8 51.55 128.1 64H27.26C16.16 64 6.537 71.59 3.912 82.38C3.1 85.78-15.71 167.2 37.07 245.9c37.44 55.82 100.6 95.03 187.5 117.4c18.7 4.805 31.41 22.06 31.41 41.37C256 428.5 236.5 448 212.6 448H208c-26.51 0-47.99 21.49-47.99 48c0 8.836 7.163 16 15.1 16h223.1c8.836 0 15.1-7.164 15.1-16c0-26.51-21.48-48-47.99-48h-4.644c-23.86 0-43.36-19.5-43.36-43.35c0-19.31 12.71-36.57 31.41-41.37c86.96-22.34 150.1-61.55 187.5-117.4C591.7 167.2 572.9 85.78 572.1 82.38zM77.41 219.8C49.47 178.6 47.01 135.7 48.38 112h80.39c5.359 59.62 20.35 131.1 57.67 189.1C137.4 281.6 100.9 254.4 77.41 219.8zM498.6 219.8c-23.44 34.6-59.94 61.75-109 81.22C426.9 243.1 441.9 171.6 447.2 112h80.39C528.1 135.7 526.5 178.7 498.6 219.8z"
                                            />
                                        </svg>
                                        數位集章
                                    </div>
                                    <div class="menu-body">
                                        透過系統上的闖關遊戲進行數位集章體驗，集滿即可獲得數位通關證書。
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- AR使用手冊 -->
        <div
            class="modal fade ar-menu-modal"
            id="arManualModal"
            tabindex="-1"
            aria-labelledby="arManualModalLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-body">
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="menu-wrapper">
                            <div class="title">川越古今使用手冊</div>
                            <div class="describe">
                                <p>
                                    綠川、柳川皆為臺中市重要的河川，同時也是老臺中人很重要的記憶之處。
                                </p>
                                <p>
                                    隨著城市變遷、時光更迭，當時老臺中人生活的景色早已有了許多的改變，不彷透過以下的老照片，來一起回憶當時臺中美麗的舊城樣貌。
                                </p>
                                <p>
                                    ps.點擊AR照片旁邊的如何抵達，即可開啟google
                                    map帶您去找藏在綠柳川裡，最佳觀賞老照片地點唷!
                                </p>
                            </div>
                            <img
                                class="w-100"
                                src="@/assets/ar_menu_img.png"
                                alt="使用手冊"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 系統建置中訊息 -->
        <div
            class="modal fade alert-modal"
            id="systemMessageModal"
            tabindex="-1"
            aria-labelledby="systemMessageModalLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered"
            >
                <div class="modal-content">
                    <div class="modal-body" style="background-color: gainsboro;">
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="clearfix"></div>
                        <div class="title">系統部分功能建置中</div>
                    </div>
                </div>
            </div>
        </div>
        <Loading :show="pageData.isLoading" />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import $ from 'jquery';
import Loading from '@/components/Loading';
import StatusAlert from '@/components/StatusAlert';
import CommonAlert from '@/components/CommonAlert';
import CommonConfirm from '@/components/CommonConfirm';
import coreMixin from '@/js/mixin/coreMixin';
import Header from '@/components/shared/Header';
import Footer from '@/components/shared/Footer';
import SideBar from '@/components/shared/SideBar';
import MapWrapper from '@/components/MapWrapper';

export default {
    name: 'App',
    mixins: [coreMixin],
    data() {
        return {};
    },
    created() {
        // 取得範圍CSV
        this.setValidScopExtent();
        // 開啟定位功能
        this.watchPosition();
    },
    async mounted() {
        if (this.$route.name === 'Home') {
            $('#userManualModal').modal('show');
            // $('#systemMessageModal').modal('show');
        }
        if (this.$route.name === 'ARMenu') {
            $('#arManualModal').modal('show');
        }
        this.setNewsList();
        this.setMappings();
        this.setDataLoading(true);
        await Promise.all([
            this.setAttractionList(),
            this.setEventList(),
            this.setRiverList(),
            this.setQrcodesList(),
        ]);
        this.setDataLoading(false);
    },
    computed: {
        ...mapState('userData', ['currentPosition']),
        ...mapState('pageData', ['show']),
    },
    methods: {
        ...mapActions('dataList', [
            'setAttractionList',
            'setEventList',
            'setNewsList',
            'setRiverList',
            'setDataLoading',
            'setMappings',
            'setQrcodesList',
        ]),
        ...mapActions('userData', [
            'setCurrentPosition',
            'setValidScopExtent',
            'setPositionErrorCode',
        ]),
        ...mapActions('pageData', ['toggleShow']),
        toggleMap() {
            this.toggleShow({ name: 'map' });
        },
        toggleShowMap() {
            this.toggleShow({ name: 'map', isShow: true });
        },
        watchPosition() {
            if (!navigator.geolocation) {
                // eslint-disable-next-line no-console
                console.log('Geolocation is not supported by this browser.');
                return;
            }
            navigator.geolocation.watchPosition(
                // success
                (pos) => {
                    this.setCurrentPosition([
                        pos.coords.longitude,
                        pos.coords.latitude,
                    ]);
                },
                // error
                (error) => {
                    // eslint-disable-next-line no-console
                    console.log(error.message);
                    this.setCurrentPosition([0, 0]);
                    this.setPositionErrorCode(error.code);
                },
                {
                    timeout: 10000,
                },
            );
        },
        getCurrentPosition() {
            this.$refs.mapWrapper.$refs.map.setMapCenter(
                ...this.currentPosition,
            );
            this.toggleShow({ name: 'map', isShow: true });
        },
        toggleLayerVisible(lyrName, isVisible) {
            this.$refs.mapWrapper.$refs.map.toggleLayerVisible(
                lyrName,
                isVisible,
            );
        },
    },
    components: {
        StatusAlert,
        CommonAlert,
        CommonConfirm,
        Loading,
        Header,
        Footer,
        SideBar,
        MapWrapper,
    },
    provide() {
        return {
            toggleLayerVisible: this.toggleLayerVisible,
        };
    },
    beforeRouteUpdate() {
        this.toggleShow({ name: 'map', isShow: false });
    },
};
</script>

<style></style>
